import { CustomFieldDto, CustomFieldTypes } from "@/store/custom-fields/types";
// @ts-ignore
import { ModalItem } from "@/components/table/generic-update-modal.vue";

export function MapCustomFieldToModalItem(field: CustomFieldDto, modalItem: ModalItem): ModalItem {
	const newModalItem: ModalItem = {
		key: "cf" + field.id.toString(),
		title: field.title,
		dataType: CustomFieldTypes[field.customFieldTypeId.toString()],
		order: modalItem.order + (field.order != null ? field.order : 999),
		readOnly: modalItem.readOnly,
	}

	return newModalItem
}
